import {
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableContainer,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import KisshtButton from "components/ui/KisshtButton";
import { RobotFont } from "components/ui/RobotFont";
import Spin from "components/ui/Spin";
import React, { useEffect, useState } from "react";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";
import { PERMISSIONS, ROUTES_VAR, ROUTE_NAME } from "shared/constants";
import {
  IsEmpty,
  readableFormatDate,
  toastSuccess,
  toastWarning,
} from "shared/utils";

import { ConfirmDialog } from "components/ui/ConfirmDialog";
import DepositVerify from "../dialogs/DepositVerify";
import { KisshtDialog } from "components/custom/KisshtDialog";
import { cancelDeposit, uploadDepositSlip } from "shared/api/deposit";
import KisshtLink from "components/ui/KisshtLink";
import { PhotoCamera } from "@material-ui/icons";
import DepositPaymentList from "./DepositPaymentList";
import ImageView from "components/ui/ImageView";

// const is_verified = ["No", "Yes"];
const DepositDetails = ({ data, depositPayments, ...props }) => {
  const [cancelDepositDialog, setCancelDepositDialog] = useState(false);
  const [despoitVerifyDialog, setDespoitVerifyDialog] = useState(false);
  const [spin, setSpin] = useState(false);
  const [imageFile, setImageFile] = useState("");
  const [showImage, setShowImage] = useState(false);

  const cancelDepositHandler = async () => {
    try {
      const res = await cancelDeposit(data["bank_deposit_reference_number"]);
      if (res.success) {
        toastSuccess(res.message);
      } else {
        toastWarning(res.message);
      }
    } catch (error) { }
  };

  const imageUploadHandler = () => {
    if (!imageFile) return false;
    setSpin(true);
    var formData = new FormData();
    formData.append("slip", imageFile);
    uploadDepositSlip(data["bank_deposit_reference_number"], formData)
      .then((res) => {
        if (res.success) {
          toastSuccess(res.message);
          document.location.reload();
        } else {
          toastWarning(res.message);
        }
        setSpin(false);
      })
      .catch((error) => {
        setSpin(false);
      });
  };

  useEffect(() => {
    imageUploadHandler();
    // eslint-disable-next-line
  }, [imageFile]);

  return (
    <Spin spinning={spin}>
      <Card>
        <CardContent className="card-content_head">
          <Grid container alignItems="center">
            <Grid item xs={6}>
              Deposit Details
            </Grid>
            <Grid item xs={6}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                {data["is_verified_label"] !== "Cancelled" && (
                  <Grid item>
                    <KisshtButton
                      route={ROUTE_NAME.deposit}
                      permission={PERMISSIONS.deposit.verify}
                      onClick={() => setDespoitVerifyDialog(true)}
                      className="common_kissht_btn"
                    >
                      Verify Deposit
                    </KisshtButton>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <CustomTableWrapper>
            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <Table className="w-full">
                <TableBody>
                  <TableBodyCell className="common_table_title">Bank Deposit Reference Number</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["bank_deposit_reference_number"]}
                  </TableBodyCell>
                </TableBody>
                {data["deposit_mode"] === "ONLINE" ? (
                  <TableBody>
                    <TableBodyCell className="common_table_title">Bank Deposit Slip Number</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      <KisshtLink
                        to={`${ROUTES_VAR.subuserPayments}/${data["bank_deposit_slip_number"]}`}
                        permission={PERMISSIONS.deposit.bank_deposit_slip_number}
                        route={ROUTE_NAME.deposit}
                      >
                        {data["bank_deposit_slip_number"]}
                      </KisshtLink>
                    </TableBodyCell>
                  </TableBody>
                ) : null}
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Amount</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <RobotFont type="medium">₹</RobotFont>
                    {data["amount"]}
                  </TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell className="common_table_title">Extra Amount</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <RobotFont type="medium">₹</RobotFont>
                    {data["extra_amount"]}
                  </TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell style={{ whiteSpace: "nowrap" }} className="common_table_title">
                    Deposit Doc Url
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["deposit_mode"] !== "ONLINE" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                      >
                        {data["deposit_doc_url"] &&
                          <ImageView
                            onClick={setShowImage}
                            open={showImage}
                            image={data["deposit_doc_url"]}
                          />}
                          
                          <KisshtButton
                           style={{border:'none',background:'none'}}
                           route={ROUTE_NAME.deposit}
                           permission={PERMISSIONS.deposit.uploadslip}
                           className="common_kissht_btn"
                          >
                        <div>
                          <input
                            onChange={(e) => setImageFile(e.target.files[0])}
                            accept="image/*"
                            style={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                          />
                          <label htmlFor="icon-button-file">
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                            >
                              <PhotoCamera />
                            </IconButton>
                          </label>
                        </div>
                        </KisshtButton>
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Deposited By</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["deposited_by"]}</TableBodyCell>
                </TableBody>
                {/* <TableBody>
                    <TableBodyCell>Payment Reason</TableBodyCell>
                    <TableBodyCell>
                      {data["payment_request_reason"]}
                    </TableBodyCell>
                  </TableBody> */}
                {/* <TableBody>
                    <TableBodyCell>Payment Receipt Mode / Source</TableBodyCell>
                    <TableBodyCell>
                      {`${data["payment_receipt_mode"]} / ${
                        data["payment_receipt_source"]
                          ? data["payment_receipt_source"]
                          : "-"
                      }`}
                    </TableBodyCell>
                  </TableBody> */}
                {/* <TableBody>
                    <TableBodyCell>Payment Status</TableBodyCell>
                    <TableBodyCell>
                      <BootstrapBadge text={data["payment_status"]} />
                    </TableBodyCell>
                  </TableBody> */}
                <TableBody>
                  <TableBodyCell className="common_table_title">Deposit Time</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["deposit_datetime"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Deposit Receive Time</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["deposit_receive_datetime"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Deposit By Subuser Name</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["deposited_by_subuser_name"]}
                  </TableBodyCell>
                </TableBody>
                {data["is_verified_label"] === "Verified" ||
                  data["is_verified_label"] === "Cancelled" ? (
                  <TableBody className="common_table_content">
                    <TableBodyCell className="common_table_title">
                      {data["is_verified_label"]} By Subuser
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["verified_by_subuser_name"]}
                    </TableBodyCell>
                  </TableBody>
                ) : null}
                <TableBody>
                  <TableBodyCell className="common_table_title">Deposit By Reference Number</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["deposited_by_reference_number"]}
                  </TableBodyCell>
                </TableBody>
              </Table>
              </TableContainer>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <table className="w-full">
                <TableBody>
                  <TableBodyCell className="common_table_title">Cash Deposit Reference Number</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["deposit_mode"] === "ONLINE" ? (
                      <KisshtLink
                        to={`${ROUTES_VAR.subuserPayments}/${data["cash_deposit_reference_number"]}`}
                        permission={PERMISSIONS.deposit.cash_deposit_reference_number}
                        route={ROUTE_NAME.deposit}
                      >
                        {data["cash_deposit_reference_number"]}
                      </KisshtLink>
                    ) : (
                      data["cash_deposit_reference_number"]
                    )}
                  </TableBodyCell>
                </TableBody>
                {/* extra_amount  */}
                <TableBody>
                  <TableBodyCell className="common_table_title">Extra Amount</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <IsEmpty value={data} itemKey={"extra_amount"}></IsEmpty>
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Is verified</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <BootstrapBadge text={data["is_verified_label"]} />
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Is Amount Adjusted</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <BootstrapBadge text={data["is_amount_adjusted"]?"YES":"NO"} />
                  </TableBodyCell>
                </TableBody>
                {data["is_amount_adjusted"] ?
                  <>
                    <TableBody>
                      <TableBodyCell className="common_table_title">Agency Name</TableBodyCell>
                      <TableBodyCell className="common_table_content">
                        {data["agency_name"]}
                      </TableBodyCell>
                    </TableBody>
                    <TableBody>
                      <TableBodyCell className="common_table_title">Deduction From</TableBodyCell>
                      <TableBodyCell className="common_table_content">
                        {data["deduction_from"]}
                      </TableBodyCell>
                    </TableBody>
                  </>:null
                }


                <TableBody>
                  <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell className="common_table_title">Deposit Mode</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["deposit_mode"]}</TableBodyCell>
                </TableBody>
                {data["operating_bank_account_name"] ? (
                  <TableBody>
                    <TableBodyCell className="common_table_title">Operating Bank Account</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["operating_bank_account_name"]}
                    </TableBodyCell>
                  </TableBody>
                ) : null}



                <TableBody>
                  <TableBodyCell className="common_table_title">Verified Time</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["verified_datetime"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["created_at"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Updated Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["updated_at"])}
                  </TableBodyCell>
                </TableBody>
              </table>
              </TableContainer>
            </Grid>
          </CustomTableWrapper>
        </CardContent>
      </Card>
      {/* {depositPayments.length ? ( */}
      <DepositPaymentList
        deposit_ref_no={data["bank_deposit_reference_number"]}
        deposit_by_ref={data["deposited_by_reference_number"]}
        data={depositPayments}
      />
      {/* // ) : null} */}
      <KisshtDialog
        title={`Verify Deposit`}
        open={despoitVerifyDialog}
        handleClose={setDespoitVerifyDialog}
      >
        <DepositVerify handleClose={setDespoitVerifyDialog} data={data} />
      </KisshtDialog>
      <ConfirmDialog
        open={cancelDepositDialog}
        handleClose={(e) => setCancelDepositDialog(false)}
        titleColor="red"
        title="Warning"
        acceptText="Submit"
        message="Once you cancel the deposit, you can't change it back."
        onAccept={cancelDepositHandler}
      />
    </Spin>
  );
};

export default DepositDetails;
